<template>
    <div class="full-chat-w single-page-container">
        <div class="content-box col-sm-8 col-xs-12">
            <div class="element-wrapper">
                <h6 class="element-header">
                    Add Copydesk Session
                </h6>
                <div class="element-box p-10">
                    <AddSessionForm :session-type="'copydesk'" :channels="channels" :languages="languages"/>
                </div>
            </div>
        </div>
        <div class="content-panel col-sm-4 col-xs-hidden middle ">
            <div class="content-panel-close">
                <i class="os-icon os-icon-close"></i>
            </div>
            <div class="element-wrapper">
                <h6 class="element-header">Guide</h6>
                <div class="element-box-tp">
                    <div class="todo-list">
                        <a class="todo-item">
                            <div class="ti-info">
                                <div class="ti-header">Channel is required</div>
                            </div>
                        </a>
                        <a class="todo-item">
                            <div class="ti-info">
                                <div class="ti-header">Session type is required</div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AddSessionForm from '@/components/common/Forms/AddSession'
import CommonFunctions from '@/mixins/common-functions.js'

export default {
  mixins: [CommonFunctions],
  components: { AddSessionForm },
  data () {
    return {
      channels: '',
      categories: '',
      languages: '',
      users: '',
      userSearch: '',
      filteredUsers: '',
      selectedUsers: []
    }
  },
  mounted () {
    this.getFormParameters()
  },
  methods: {
    getFormParameters () {
      var self = this

      const url = '/photodesk/session/add/helper'
      this.$http
        .get(url, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          console.log(response)
          self.channels = response.data.channels
          self.languages = response.data.languages
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text: error.response.data || 'Something went wrong',
            show: true
          })
        })
    }
  }
}
</script>

<style scoped>
.single-page-container {
  padding: 20px;
}
.content-panel {
  padding: 1rem;
}
</style>
